import React, { useEffect, useState } from 'react';

import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';

import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { useVehiclesContext } from '../../../../../context/vehicles/vehicles.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import useForm from '../../../../../helpers/useForm';
import VehicleDetailsValidations from './PatentEngineChassis.validations';

const PatentEngineChassis = () => {
  const { vehicle } = useVehiclesContext();
  const { nextStep, updateEndorsementBody } = useEndorsementsDataContext();
  const { user } = useAuthDataContext();

  const [defaultValues, setDefaultValues] = useState({
    license_plate: vehicle?.license_plate || '',
    engine_number: vehicle?.engine_number || '',
    chassis_number: vehicle?.chassis_number || '',
  });

  useEffect(() => {
    setDefaultValues({
      license_plate: vehicle?.license_plate || '',
      engine_number: vehicle?.engine_number || '',
      chassis_number: vehicle?.chassis_number || '',
    });
  }, [vehicle]);

  const onSubmit = () => {
    if (
      values.license_plate !== vehicle.license_plate ||
      values.chassis_number !== vehicle.chassis_number ||
      values.engine_number !== vehicle.engine_number
    ) {
      updateEndorsementBody({
        endorsement_type: 'vehicle',
        license_plate:
          vehicle?.license_plate !== values.license_plate
            ? values.license_plate
            : undefined,
        engine_number:
          vehicle?.engine_number !== values.engine_number
            ? values.engine_number
            : undefined,
        chassis_number:
          vehicle?.chassis_number !== values.chassis_number
            ? values.chassis_number
            : undefined,
      });
      dataLayerPush('modificar_poliza_vehiculo_continuar', user?.id);
      nextStep();
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    onSubmit,
    VehicleDetailsValidations,
    defaultValues,
    vehicle
  );

  const [counterDiff, setCounterDiff] = useState(false);

  useEffect(() => {
    let differents: any = {
      license_plate: false,
      engine_number: false,
      chassis_number: false,
    };

    if (vehicle?.license_plate !== values.license_plate) {
      differents.license_plate = true;
    } else {
      differents.license_plate = false;
    }

    if (vehicle?.engine_number !== values.engine_number) {
      differents.engine_number = true;
    } else {
      differents.engine_number = false;
    }

    if (vehicle?.chassis_number !== values.chassis_number) {
      differents.chassis_number = true;
    } else {
      differents.chassis_number = false;
    }

    const counter = Object.values(differents).some(
      (element) => element === true
    );

    setCounterDiff(counter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.license_plate, values.engine_number, values.chassis_number]);

  return (
    <>
      {!!Object.keys(vehicle).length && (
        <>
          <Grid container justify="center">
            <Grid item xs={11} sm={10} lg={8}>
              {/* VEHCILE INFO */}

              <Grid container>
                <Grid item xs={12}>
                  <Box mt={6}>
                    <Typography variant="h3">Cambios en tu vehículo</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box my={2}>
                    <Typography variant="caption">Patente *</Typography>
                  </Box>
                  <Box mr={2}>
                    <TextField
                      error={Boolean(errors['license_plate'])}
                      helperText={errors['license_plate']}
                      size="small"
                      fullWidth={true}
                      name="license_plate"
                      id="license_plate"
                      placeholder="Ingresá la patente"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.license_plate}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box my={2}>
                    <Typography variant="caption">N° de motor *</Typography>
                  </Box>

                  <Box mr={2}>
                    <TextField
                      error={Boolean(errors['engine_number'])}
                      helperText={errors['engine_number']}
                      size="small"
                      fullWidth={true}
                      name="engine_number"
                      id="engine_number"
                      placeholder="Ingresá el N° de motor"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.engine_number}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box my={2}>
                    <Typography variant="caption">N° de chasis *</Typography>
                  </Box>

                  <Box mr={2}>
                    <TextField
                      error={Boolean(errors['chassis_number'])}
                      helperText={errors['chassis_number']}
                      size="small"
                      fullWidth={true}
                      name="chassis_number"
                      id="chassis_number"
                      placeholder="Ingresá el N° de chasis"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.chassis_number}
                    />
                  </Box>
                </Grid>
                {errors['limitChanges'] && (
                  <Grid xs={12}>
                    <Typography color="error">
                      {errors['limitChanges']}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid
              item
              xs={11}
              sm={10}
              lg={8}
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Box>
                <Box mb={2} mt={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={!!Object.keys(errors).length || !counterDiff}
                  >
                    Continuar
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default PatentEngineChassis;
